
// src/services/woserviceApi.ts
import { ENV } from "@app/constants/env";
import { WoserviceCreateType } from "@feature/types/wo.service.create.type";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";



export const multiServicesSlice = createApi({
  reducerPath: "multiServicesSlice",
  baseQuery: fetchBaseQuery({ baseUrl: `${ENV.BASE_API_URL +ENV.JOB_APIURL}/WorkOrderService` }), // adjust base URL
  endpoints: (builder) => ({
    createMultipleService: builder.mutation<number[], WoserviceCreateType[]>({
      query: (services) => ({
        url: "/CreateMultipleService",
        method: "POST",
        body: services
      })
    })
  })
});

export const { useCreateMultipleServiceMutation } = multiServicesSlice;
